import { constructionAsset, constructionSafety, logisticsAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import video from '@src/assets/images/solution/medicalPatient/video/rtlsVideo.mp4';

export default {
  desc: 'Beacon là một trong những công nghệ đổi mới của thời đại kỹ thuật số hiện đại, được ứng dụng trong đời sống hàng ngày và các lĩnh vực kinh doanh của chúng ta. Chúng ta hãy cùng tìm hiểu xem beacon là gì, hoạt động như thế nào và các lĩnh vực ứng dụng của nó.',
  keywords: 'beacon, bluetooth, ble, rtls, location tracking, orbro',
  ogSite: 'Beacon là gì?',
  title: 'Beacon là gì?',
  ogUrl: 'https://orbro.io/vi/blog/beacon',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AK0iWDxa-ucISW1k_6fC9t-ZpGPIV1qRXWXcZO1OhYuIe-j3MLl1BdXVIIv40aG69pNCT6AD0WANYJ1p4OjzDQF9yM8_m5CaFglWOtunF7ZF0uySt_dYAB4pE7shLBOrdeIkyxz_3esBC_Qd-x3FmnZ4jLNcZazyIYAPR_ZuRbLW2E_sui_6vQWc2_iABmwSImfVtoyWAhaCjoHOk7UonwVJTlXVq-NJmIqcpT0-KgFYxoTYR_i_qaS1PR8hzLVcOzzk1Z7ng11UP9IaQiWcX6pFAZnxvGsUJDNz9eiIxIRifGlSF2rGl3O6KQKRRdOU1LATUHY1Rkym6F5nLo87mxlA9iqybXGIED_3BG2ywgaf3uYgBloZH3CGqi4IMUUD-dN7cbbwxrQyiEppY9GA0xNk9uatZggX5TaYItKRL0fGmJXsHn18bQHWue-OCSVs_IjMmQ6omlyiJiQAVMSGu65C3hd8ZIQGZDq0EzutRLIXyb7f6OVVcogIw8fmAHnyhzYh-ffT1Rl0kp7BSYB0y-ooqoM_z3ut5Znu5TWC4EndXrRa4BB7KOnh--fa8H0-rbNiorUZmhoedmMZHCUuHKEjiyshQaX9UiAn2Rr-Uvtuvqs-TYIRAHroGgOBrzaGBEycwr3rifKxJx-fBbAO8fe7xhZD8RNeniCCIXkf4o_crQdpMZuDeKh5_f7URFr8NU_5vs74I1lhdV_Bgq5bYEI0-b7N7JV4-Wr_zSbOLTMb5EZ-vyj43hGUKLdgOUHTYYNP8plRV5_UMElexKEid5ZmX2aj1QrTT9zBm5c_SunfkZOEK6kY6GuV7NagmSgQDhcVmX_Qgf9tJoEw07dJxwXPxOzZPO5nZDkX_xA1oDKNNsgNpPXuVjmEI2K_O-syucjYFlVnVagL7aQ-V4givU9qKYBasb6s2hfajR4L4BAvyBp-EiItjTy3dK4H8fk1sdf6OlqMfNS3DQqBu5gpyMD28HyW0gk7wC-hs0C3EsglleW016V9ELEcMiX9OTvM1dozJQFzpMEXve9fw44h-D0lW5MuJIfDb_HvD4FB0ZVrab-8kKD-99NVk2mfZigqE3tPXhEb559joMsf5UYlRvjLz7DqnBmNwPBMQavjtKTmwq6gPHsLn4hR2ENgscKrdmGFYbt-pSwwinouRHIWBOAeLbIU4R9AOWId11R5oG0IFEuiAib3dTKuzObWCeWjN4aP-24uX46l_DnyL1K9zDS3MOZbqbQOaTjkTIsx7FlLrk1iw5P3RxjboS7VC048bElpy68OsGGr5c30D4owv38GeXx3eQm4P8RDq7Ubxe9W3Z1a-CNQhDMGEBpns6BLrZ2d8AO3TaS7HhGcvmbbGMsdgmoPRZgElmoN6l1a7ktrDjuTD2NWNvLUJ6d7WxCpEG9S5RClt8JSoR884w_PQAONR_WMbvHpL-xm_fuWqWDDpYT1_7ScbWFIwBwUTop8jrIiPrrgrHHNAVloR9YwiH3J_U5jMMK9rNENYv9rHahEOLrwcJzGzbnbbkocERqVusvbsC1pl-fPUAVDjtgKf89d9X6FPsVJ95xED_hnGthC4JfXqLnPbKG_=w3356-h2242',
  ogType: 'website',
  date: '2023-11-08',
  tag1: '#Beacon',
  tag2: '#Bluetooth',
  tag3: '#Ble',
  tag4: '#Orbro',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Beacon là một trong những công nghệ đổi mới của thời đại kỹ thuật số hiện đại, được ứng dụng trong đời sống hàng ngày và các lĩnh vực kinh doanh của chúng ta. Chúng ta hãy cùng tìm hiểu xem beacon là gì, hoạt động như thế nào và các lĩnh vực ứng dụng của nó.',
      dot: '',
    },
    {
      head: 'Beacon là gì?',
      subHead: '',
      desc: 'Beacon là một thiết bị phát sóng vô tuyến nhỏ, có vai trò truyền thông tin đến các thiết bị thông minh ở một vị trí cụ thể bằng cách sử dụng giao tiếp không dây. Nó chủ yếu sử dụng công nghệ Bluetooth Low Energy (BLE) và nổi bật với kích thước nhỏ gọn cùng khả năng tiêu thụ điện năng thấp. Những chiếc beacon này có thể thông báo sự hiện diện và vị trí của chúng cho môi trường xung quanh.',
      dot: '',
    },
    {
      head: 'Nguyên lý hoạt động của Beacon',
      subHead: '',
      desc: 'Beacon có nguyên lý hoạt động rất đơn giản. Beacon định kỳ phát ra tín hiệu, và các thiết bị thông minh ở gần (ví dụ: điện thoại thông minh) sẽ phát hiện tín hiệu này và xác định vị trí của beacon đó. Thông qua đó, thiết bị thông minh có thể thực hiện một số tác vụ nhất định tại một vị trí cụ thể.',
      dot: '',
    },
    {
      head: 'Lĩnh vực ứng dụng',
      subHead: '',
      desc: 'Beacon đang được ứng dụng trong nhiều lĩnh vực khác nhau. Trong số đó, các lĩnh vực sau đây đang nhận được sự chú ý lớn:',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tiếp thị và Quảng cáo:',
      desc: 'Tại các cửa hàng hoặc bảo tàng, có thể sử dụng beacon để cung cấp cho khách hàng các chương trình giảm giá đặc biệt, thông tin, hoặc truyền tải quảng cáo một cách hiệu quả hơn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Dịch vụ dựa trên vị trí:',
      desc: 'Sử dụng beacon để cung cấp thông tin vị trí chính xác trong nhà và cải thiện chức năng điều hướng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Nhà thông minh và IoT:',
      desc: 'Sử dụng beacon để kết nối các thiết bị thông minh khác nhau trong gia đình, đồng thời tăng cường khả năng tự động hóa và sự tiện lợi.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Chăm sóc sức khỏe:',
      desc: 'Ứng dụng trong việc theo dõi bệnh nhân và các thiết bị y tế để nâng cao chất lượng dịch vụ y tế.',
      dot: '',
    },
    {
      head: 'Ưu điểm',
      subHead: '',
      desc: 'So với các công nghệ dựa trên vị trí khác, công nghệ beacon có một số ưu điểm:',
      dot: '',
    },
    {
      head: '',
      subHead: 'Độ chính xác:',
      desc: 'Beacon cung cấp thông tin vị trí chính xác và hoạt động ngay cả trong những môi trường mà tín hiệu GPS không thể tiếp cận, chẳng hạn như bên trong các tòa nhà.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tiêu thụ điện năng thấp:',
      desc: 'Beacon có tuổi thọ pin dài nhờ khả năng tiêu thụ điện năng thấp.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tính đơn giản:',
      desc: 'Beacon dễ dàng cài đặt và quản lý.',
      dot: '',
    },
    {
      head: 'Lời kết',
      subHead: '',
      desc: 'Với sự phát triển của công nghệ hiện đại, beacon là một trong những công nghệ quan trọng có ảnh hưởng lớn đến đời sống hàng ngày và hoạt động kinh doanh của chúng ta. Lĩnh vực ứng dụng của nó đang không ngừng được mở rộng, và trong tương lai, nó được kỳ vọng sẽ mang đến nhiều dịch vụ và cơ hội đổi mới đa dạng hơn nữa. Chúng ta hãy cùng kỳ vọng vào tương lai của beacon và ứng dụng công nghệ này để làm cho cuộc sống của mình ngày càng thông minh và tiện lợi hơn.',
      dot: '',
    },
  ],

  link: {
    page: 'access',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.auto.accessauto.title,
        title: productPurchase.purchase.auto.accessauto.title,
        serial: productPurchase.purchase.auto.accessauto.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.accessauto.key1,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
